/** @param {HTMLElement} root */
const buildAsideFromAnchors = (root) => {
  const inner = root.querySelector('.blog-content__aside-inner');
  const main = root.querySelector('.blog-content-main-column');
  if (!inner || !main) return [];

  inner.replaceChildren();
  const targets = main.querySelectorAll('.blog-anchor-target');
  let firstLink = true;

  targets.forEach((target) => {
    const id = target.id;
    if (!id) return;
    const heading = target.querySelector('.blog-anchor-target__heading, h2');
    const label = heading?.textContent?.trim();
    if (!label) return;

    const a = document.createElement('a');
    a.className = 'blog-content__aside-link';
    if (firstLink) {
      a.classList.add('is-active');
      firstLink = false;
    }
    a.href = `#${id}`;
    a.textContent = label;
    inner.appendChild(a);
  });

  return Array.from(main.querySelectorAll('.blog-anchor-target'));
};

/** @param {HTMLElement} root */
const initBlogContentNav = (root) => {
  if (root.dataset.blogContentNavInitialized) return;
  root.dataset.blogContentNavInitialized = 'true';

  const targets = buildAsideFromAnchors(root);
  const links = root.querySelectorAll('.blog-content__aside-link');

  if (!links.length || !targets.length) return;

  /** @param {Element} link */
  const activate = (link) => {
    links.forEach((l) => l.classList.remove('is-active'));
    targets.forEach((t) => t.classList.remove('is-active'));
    link.classList.add('is-active');
    const href = link.getAttribute('href');
    const target = href ? root.querySelector(href) : null;
    if (target) target.classList.add('is-active');
  };

  let scrollLocked = false;
  const observer = new IntersectionObserver(
    (entries) => {
      if (scrollLocked) return;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const matching = root.querySelector(
            `.blog-content__aside-link[href="#${entry.target.id}"]`,
          );
          if (matching) activate(matching);
        }
      });
    },
    { threshold: 0.3 },
  );

  targets.forEach((t) => observer.observe(t));

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      const target = href ? root.querySelector(href) : null;
      if (target) {
        scrollLocked = true;
        activate(link);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => {
          scrollLocked = false;
        }, 900);
      }
    });
  });

  const first = links[0];
  if (first) activate(first);
};

const initAllBlogContentNavs = () => {
  document.querySelectorAll('.blog-content-grid').forEach((el) => {
    if (el instanceof HTMLElement) initBlogContentNav(el);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllBlogContentNavs, { once: true });
} else {
  initAllBlogContentNavs();
}

document.addEventListener('shopify:section:load', (e) => {
  if (!(e.target instanceof Element)) return;
  const grid = e.target.querySelector('.blog-content-grid');
  if (grid instanceof HTMLElement) initBlogContentNav(grid);
});
